var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-controller"},[(_vm.controllerType == 'setting')?_c('SettingController',{attrs:{"borderColor":_vm.borderColor},on:{"doCommand":_vm.onDoCommand}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }